import type { DxSelectBox } from "devextreme-vue";
import { getSelectBoxDefaultProperties } from "./grid-helper";
import { useIntl } from "../services/i18n";
import { EstadoLibreTramiteEnergiaEnum, GrupoEmpresaEnergiaEnum, OrigenConocimientoCupsEnum, SubtipoPersonaEnum, TipoCalefaccionEnum, TipoCalentadorEnum, TipoCocinaEnum, TipoComunicadoEnum, TipoCosteGestionEnum, TipoDocumentoEnum, TipoEmpresaAgentesEnum, TipoInmuebleEnum, TipoObraEnum, TipoPersonaEnum, TipoRepresentanteCcppEnum, TipoSuministroTramiteEnergiaEnum, TipoTramiteOperacionEnum } from "../.api";

type TranslatedEnumItem = {
  value: string;
  text: string;
};

const getEnumName = (apiEnum: unknown): string => {
  switch (apiEnum) {
    case TipoTramiteOperacionEnum:
      return "tipo_tramite_operacion";
    case TipoPersonaEnum:
      return "tipo_persona";
    case SubtipoPersonaEnum:
      return "subtipo_persona";
    case TipoRepresentanteCcppEnum:
      return "tipo_representante_ccpp";
    case TipoInmuebleEnum:
      return "tipo_inmueble";
    case TipoObraEnum:
      return "tipo_obra";
    case TipoCalentadorEnum:
      return "tipo_calentador";
    case TipoCalefaccionEnum:
      return "tipo_calefaccion";
    case TipoCocinaEnum:
      return "tipo_cocina";
    case TipoComunicadoEnum:
      return "tipo_comunicado";
    case TipoDocumentoEnum:
      return "tipo_documento";
    case TipoEmpresaAgentesEnum:
      return "tipo_empresa_agentes";
    case TipoSuministroTramiteEnergiaEnum:
      return "tipo_suministro_tramite_energia";
    case GrupoEmpresaEnergiaEnum:
      return "grupo_empresa_energia";
    case TipoCosteGestionEnum:
      return "tipo_coste_gestion";
    case OrigenConocimientoCupsEnum:
      return "origen_conocimiento_cups";
    case EstadoLibreTramiteEnergiaEnum:
      return "estado_libre_tramite_energia";
    default:
      throw new Error(`Enum ${apiEnum} not supported`);
  }
}

const getSelectBoxFromApiEnum = <T extends Record<string, string | number>>(apiEnum: T): DxSelectBox => {
  
  let dataSource = getTranslatedListApiEnum(apiEnum);
  const selector = {...getSelectBoxDefaultProperties(),
    dataSource: dataSource,
    displayExpr: 'text',
    valueExpr: 'value',
  };
  return selector;
}

const translateEnum = <T extends Record<string, string | number>>(apiEnum: T, value: string): string => {
  let enumValues = getTranslatedListApiEnum(apiEnum);
  return enumValues.find(item => item.value === value)?.text ?? value;
}

const getTranslatedListApiEnum = <T extends Record<string, string | number>>(apiEnum: T): TranslatedEnumItem[] => {
  const intl = useIntl();
  let enumName = getEnumName(apiEnum);
  return Object.keys(apiEnum).map(key => ({
    value: apiEnum[key] as string,
    text: intl.i18n.t(`shared.enums.${enumName}.${apiEnum[key]}`)
  }));
}

export { getSelectBoxFromApiEnum, getTranslatedListApiEnum, translateEnum };